import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { themeTokens, text, space } from "@octopusdeploy/design-system-tokens";
import { isValidPageInstanceSummary, usePageInstanceSummary } from "@octopusdeploy/portal-routes";
import * as React from "react";
import CloseButton from "~/components/Button/CloseButton";
import { useIsDevToolsOpen, useToggleDevTools } from "~/components/DevTools/DevToolsContext";
interface DevBannerProps {
    onClose(): void;
}
export const DevBanner: React.FC<DevBannerProps> = ({ onClose }) => {
    const page = usePageInstanceSummary();
    const isValidPage = isValidPageInstanceSummary(page);
    const handleClose = React.useCallback(onClose, [onClose]);
    const toggleDevTools = useToggleDevTools();
    const isDevToolsOpen = useIsDevToolsOpen();
    return (<div className={styles.devBanner}>
            <div className={styles.entries}>
                <span>
                    Current Page: {page && page.Id} {isValidPage && `(Owned by ${page.owner})`}
                </span>
                <span>
                    <a href="#" onClick={(e) => {
            e.preventDefault();
            toggleDevTools();
        }}>
                        {isDevToolsOpen ? (<span>
                                Close Dev Tools <pre style={{ display: "inline" }}>ctrl+shift+~</pre>
                            </span>) : (<span>
                                Open Dev Tools <pre style={{ display: "inline" }}>ctrl+shift+~</pre>
                            </span>)}
                    </a>
                </span>
                <span>
                    Design System: <ExternalLink href="https://www.octopus.design/">Overview</ExternalLink> | <ExternalLink href="https://www.octopus.design/latest/components/overview-ph4pCAwG">Components</ExternalLink>
                </span>
                <span>
                    Component Showcase: <ExternalLink href="https://components.octopus.design/?path=/docs/welcome--docs">Hosted</ExternalLink> | <ExternalLink href="http://localhost:6006">Local</ExternalLink>
                </span>
            </div>
            <div>
                <CloseButton onClose={handleClose}/>
            </div>
        </div>);
};
DevBanner.displayName = "DevBanner"
const styles = {
    devBanner: css({
        backgroundColor: themeTokens.color.callout.background.info.default,
        color: themeTokens.color.text.info,
        font: text.body.regular.small,
        display: "flex",
        flexDirection: "row",
    }),
    entries: css({
        display: "flex",
        flex: 1,
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: `${space[4]} ${space[24]}`,
    }),
};
